import { render, staticRenderFns } from "./PriceQuotationAffiliateOperationChangeActivationType.vue?vue&type=template&id=85a32562&"
import script from "./PriceQuotationAffiliateOperationChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./PriceQuotationAffiliateOperationChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports